const common = {
   // _baseURL: "https://floating-refuge-81787.herokuapp.com/", 
   // _baseURL: "http://localhost:8080/", 
   // _baseURL: "http://localhost/", 
   // _baseURL: "http://18.222.144.22/", 
   _baseURL: 'http://admin.cicadalabsok.com/'
}

module.exports = { common }